import {styled} from "@mui/material/styles"

export const BurgerBodyContainer = styled("div")`
    height: 100%;
    flex: 1 1 auto;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    border-top: none;
`
